<template>
  <div
    :class="['absolute w-full flex flex-col  justify-center items-center z-20 bg-gray-200 rounded', withBg ? 'bg-opacity-90 h-full' : 'bg-opacity-0 h-max']">
    <div class="flex flex-col  justify-center items-center p-4 rounded-xl" :class="{'bg-gray-200': !withBg}">
      <img src="../../../../assets/img/admin/premium.png" alt="diamond logo" class="w-8 h-8 mb-4">
      <span class="font-medium text-center mb-2 bg-gray-200 px-2 rounded">יכולת זו אינה זמינה במסלול שלך</span>
      <span class="font-light text-sm text-center mb-2 bg-gray-200 p-2 rounded">אנו מתנצלים, אך יכולת זו אינה קיימת במסלול שבחרתם. לשאלות נוספות ולשדרוג מסלול שלחו לנו הודעה.</span>
      <send-us-a-message :message="message"/>
    </div>
  </div>
</template>

<script setup lang="ts">

import SendUsAMessage from "@app/components/admin/components/SendUsAMessage.vue";

const props = defineProps({
  message: {required: false, type: String, default: 'היי, אשמח לקבל עוד פרטים לגבי שדרוג מסלול'},
  withBg: {required: false, type: Boolean, default: true}
})
</script>

<style scoped lang="scss">

</style>
